export default __webpack_public_path__ + "static/cafe_36063-85af58b48c94ec11653aa5297ff09401.png";